import { render, staticRenderFns } from "./CustomDefinedFieldInput.vue?vue&type=template&id=1afdc546&scoped=true"
import script from "./CustomDefinedFieldInput.vue?vue&type=script&lang=ts"
export * from "./CustomDefinedFieldInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afdc546",
  null
  
)

export default component.exports